import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '@saas-kit/lib';
import { FullPageSpinner } from '@saas-kit/ui';

interface Props {
  children: ReactNode;
}

export function RequireAdmin({ children }: Props): JSX.Element {
  const hydrated = useAuth((s) => s.hydrated);
  const user = useAuth((s) => s.user);
  const location = useLocation();

  if (!hydrated) return <FullPageSpinner />;
  if (!user || !user.is_platform_admin) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/login?next=${next}`} replace />;
  }

  return <>{children}</>;
}
